<template>
    <div id="services" class="container">
        <div class="row">
            <h1 data-aos="fade-up">{{ msg }} </h1>
            <hr>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.uno.numero}}</span> {{servicios.uno.nombre}}</h3>
                       <h5>{{servicios.uno.desc}}
                          <span id="textShowing" class="textShowing" v-show="whenClicked">{{servicios.uno.rest}}</span>
                       </h5>
                    <a :class="{mostrar: visible}" v-on:click="toggle">{{show}}</a>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.dos.numero}}</span> {{servicios.dos.nombre}}</h3>
                       <h5>{{servicios.dos.desc}}
                          <span class="textShowing" v-show="whenClicked2">{{servicios.dos.rest}}</span>
                       </h5>
                    <a :class="{mostrar: visible}" @click="toggle2">{{show2}}</a>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.tres.numero}}</span> {{servicios.tres.nombre}}</h3>
                       <h5>{{servicios.tres.desc}}
                          <span class="textShowing" v-show="whenClicked3">{{servicios.tres.rest}}</span>
                       </h5>
                    <a :class="{mostrar: visible}" @click="toggle3">{{show3}}</a>
                  </div>
            </div>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.cuatro.numero}}</span> {{servicios.cuatro.nombre}}</h3>
                       <h5>{{servicios.cuatro.desc}}
                          <span class="textShowing" v-show="whenClicked4">{{servicios.cuatro.rest}}</span>
                       </h5>
                    <a :class="{mostrar: visible}" @click="toggle4">{{show4}}</a>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.cinco.numero}}</span> {{servicios.cinco.nombre}}</h3>
                       <h5>{{servicios.cinco.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.seis.numero}}</span> {{servicios.seis.nombre}}</h3>
                       <h5>{{servicios.seis.desc}}
                       </h5>
                  </div>
            </div>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.siete.numero}}</span> {{servicios.siete.nombre}}</h3>
                       <h5>{{servicios.siete.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.ocho.numero}}</span> {{servicios.ocho.nombre}}</h3>
                       <h5>{{servicios.ocho.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.nueve.numero}}</span> {{servicios.nueve.nombre}}</h3>
                       <h5>{{servicios.nueve.desc}}
                       </h5>
                  </div>
            </div>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.diez.numero}}</span> {{servicios.diez.nombre}}</h3>
                       <h5>{{servicios.diez.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.once.numero}}</span> {{servicios.once.nombre}}</h3>
                       <h5>{{servicios.once.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.dose.numero}}</span> {{servicios.dose.nombre}}</h3>
                       <h5>{{servicios.dose.desc}}
                       </h5>
                  </div>
            </div>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.trece.numero}}</span> {{servicios.trece.nombre}}</h3>
                       <h5>{{servicios.trece.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.catorce.numero}}</span> {{servicios.catorce.nombre}}</h3>
                       <h5>{{servicios.catorce.desc}}
                       </h5>
                  </div>
            </div>
            <div class="col-xs-12 col-md-4 espacio">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.quince.numero}}</span> {{servicios.quince.nombre}}</h3>
                       <h5>{{servicios.quince.desc}}
                       </h5>
                  </div>
            </div>
        </div>
        <div class="row" data-aos="fade-up">
            <div class="col-xs-12 col-md-4 espacio ultima">
                   <div id="parrafox">
                     <h3>
                       <span>{{servicios.dieciseis.numero}}</span> {{servicios.dieciseis.nombre}}</h3>
                       <h5>{{servicios.dieciseis.desc}}
                       </h5>
                  </div>
            </div>
        </div>
    </div>
</template>

<script>
// import servicesInfo from './servicesinfo'
export default {
    name: 'services',
    data() {
        return {
            whenClicked: false,
            whenClicked2: false,
            whenClicked3: false,
            whenClicked4: false,
            whenClicked5: false,
            visible: false,
            show: 'Show more...',
            show2: 'Show more...',
            show3: 'Show more...',
            show4: 'Show more...',
            show5: 'Show more...',
            msg: 'OUR SERVICES',
            servicios: {
                uno: {
                    numero: '1',
                    nombre: 'TECH CONSULTING',
                    desc: 'Solutions Integration Services - Become the facilitator in new business opportunities - Introduce customers to potential technology partners -',
                    rest: 'Arrange webinars and training courses based on the needs of our customers - Become sales representative for our partners in their solutions and products to provide the widest array of opportunities',
                    show: 'Show more...',
                    showless: 'Show less...'
                },

                dos: {
                    numero: '2',
                    nombre: 'INTERNET OF THINGS',
                    desc: 'Working with customers in the M2M/IoT area to assist in seeking growth in additional verticals - Help create an IoT wireless business division',
                    rest: 'plan for customers - Make specific carrier business relationship recommendations - Create new wireless manufacturer (OEM) relationships and help them with their IoT strategy - Introduce customers to potential wireless and IoT partners - Review potential strategic partnership targets as LoRa, SigFox, and others',
                    show: 'Show more...'
                },
                tres: {
                    numero: '3',
                    nombre: 'WIRELESS',
                    desc: 'Provide a complete understanding on the USA and Latin America Carrier’s acceptance processes - Technical representation for OEMs during',
                    rest: 'Carriers’ acceptance processes - Ensure full understanding of carriers’ technical requirements - Assist in setting test plans and act as a consultative expert for our customers - Provide quality account and control management - Connecting OEMs with possible business partners for forward and reverse Logistic',
                    show: 'Show more...'
                },
                cuatro: {
                    numero: '4',
                    nombre: 'TESTING',
                    desc: 'Provide debugging services and error fix verification - Improve the quality of products by using our crowd testing services - Enhance',
                    rest: 'efficiency and offer high scalability on apps development and testing (Android and IOS) - Understand customers need to create a customized test plan and support the execution - Localize testing using a variety of real devices and software which have been launched in the target market - Provide user interface, feature and functionality verifications to enhance the quality of our customers’ products and services.',
                    show: 'Show more...'
                },
                cinco: {
                    numero: '5',
                    nombre: 'SEM',
                    desc: 'Search Engine Optimization: Search Engine Marketing',
                },
                seis: {
                    numero: '6',
                    nombre: 'DATABASES',
                    desc: 'Design, optimization, development, administration - Web Services: rest api, SOAP - Server Administration: Amazon Web Sevices',
                },
                siete: {
                    numero: '7',
                    nombre: 'SOFTWARE',
                    desc: 'Tailor Made - Platforms: Windows, Mac OSX, Linux',

                },
                ocho: {
                    numero: '8',
                    nombre: 'DESIGN',
                    desc: 'UI/UX - Development - Applications: PHP, RUBY, NODEJS - Hosting - Content Administrations',
                },
                nueve: {
                    numero: '9',
                    nombre: 'MOBILE DESIGN',
                    desc: 'UI/UX - Mobile Development: IOS, Android, Windows, Blackberry - Publish and Distribution',
                },
                diez: {
                    numero: '10',
                    nombre: 'GAME DESIGN',
                    desc: 'UI/UX - Gameplay - Development - Assets: 2D, 3D',
                },
                once: {
                    numero: '11',
                    nombre: 'WEB',
                    desc: 'Design - Development - Hosting',
                },
                dose: {
                    numero: '12',
                    nombre: 'APPS',
                    desc: 'Design - Development - Publish & Distribution',
                },
                trece: {
                    numero: '13',
                    nombre: 'DATA SERVICES',
                    desc: 'Databases - Web Services - Server Administration',
                },                
                catorce: {
                    numero: '14',
                    nombre: 'SEO / SEM',
                    desc: 'Search Engine Optimization - Search Engine Marketing',
                },                
                quince: {
                    numero: '15',
                    nombre: 'SOFTWARE',
                    desc: 'Tailor made - Windows - Mac OSX - Linux',
                },                
                dieciseis: {
                    numero: '16',
                    nombre: 'VIDEOGAMES',
                    desc: 'Design - Development - Assets (2D / 3D)',
                },

            }
        }

    },
    methods: {
      toggle: function() {
            this.whenClicked = !this.whenClicked
            // this.visible = !this.visible
            this.whenClicked ? this.show = 'Show less...' : this.show = 'Show more...'
        },
        toggle2: function() {
            this.whenClicked2 = !this.whenClicked2
            // this.visible = !this.visible
            this.whenClicked2 ? this.show2 = 'Show less...' : this.show2 = 'Show more...'
        },
        toggle3: function() {
            this.whenClicked3 = !this.whenClicked3
            // this.visible = !this.visible
            this.whenClicked3 ? this.show3 = 'Show less...' : this.show3 = 'Show more...'
        },
        toggle4: function() {
            this.whenClicked4 = !this.whenClicked4
            // this.visible = !this.visible
            this.whenClicked4 ? this.show4 = 'Show less...' : this.show4 = 'Show more...'
        },
        toggle5: function() {
            this.whenClicked5 = !this.whenClicked5
            // this.visible = !this.visible
            this.whenClicked5 ? this.show5 = 'Show less...' : this.show5 = 'Show more...'
        }
    },
    components: {
        // servicesInfo
    },
    mounted(){
        // this.toggle()
    }
}
</script>

<style scoped>

.ultima{
    margin-bottom:60px;
}

.espacio{
    /* height: 330px; */
}
.mostrar {
    display: none;
}

a {
    font-weight: bolder;
    color: #f86d10;
    z-index: 999;
}

a:hover {
    text-decoration: none;
}

.show {
    display: block;
}

.notShow {
    display: none;
}

#textShowing {
    color: #333434;
}

.textShowing{
     color: #333434;
}

details {
    height: 280px;
    cursor: pointer;
}

details.focus {
    box-shadow: none;
}

summary::-webkit-details-marker {
    display: none;
}

summary:after {
    content: "+";
    color: #333434;
    float: right;
    font-size: 1.5em;
    font-weight: bold;
    margin: -30px 10px 0 0;
    padding: 0;
    text-align: center;
    width: 20px;
    display: none;
}

details[open] summary:after {
    content: "-";
}

h1 {
    font-weight: bold;
    padding-top: 70px;
    color: #333434;
}

h3 {
    text-align: left;
    font-weight: bold;
    color: #333434 !important;
}

h5 {
    text-align: justify;
    line-height: 15pt;
}

span {
    color: #f86d10;
    font-weight: lighter;
}

hr {
    border-width: 2px;
    width: 10%;
    border-color: #f86d10;
}

.container {
    height: 100vh;
}

/* horizontal tablet */
@media screen and (max-width: 1024px)
{
    .espacio{
        /* height: 360px !important; */
    }
}


/* tablet */

@media screen and (max-width: 991px) {


    .espacio{
        /* height: 210px !important; */
    }
}



/* mobile */

@media screen and (max-width: 767px) {
    .container {
        height: auto;
    }

        .espacio{
        /* height: 300px !important; */
    }
}

/*mobile horizontal*/
@media screen and (max-width: 737px){
    .espacio{
        /* height: 220px !important; */
    }
}

@media screen and (max-width: 568px){
        .espacio{
        /* height: 270px !important; */
    }
}

@media screen and (max-width: 415px){
            .espacio{
        /* height: 340px !important; */
    }
}

/* smaller mobile */
@media screen and (max-width: 323px) {

    .espacio{
       /* height: 380px !important; */
    }
}
</style>




// WEBPACK FOOTER //
// src/components/services.vue